<template>
  <div class="index">
    <!-- 头部导航轮播 -->
    <header class="header">
      <img src="../../static/header_bg.png" alt="导航背景" width="100%">
      <img src="../../static/logo.png" alt="导航">
    </header>
    <!-- 轮播 -->
    <div class="Carousel">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <!-- 默认易胜博介绍 -->
          <div class="swiper-slide">
            <img class="slide-img" src="../../static/banner1.jpg" alt="" width="100%">
            <div class="Introduction">
              <div class="Introduction-header">
                <div class="name">关于易胜博</div>
                <div class="resume">易胜博体育(YSB Sports)创始于1995年，在1997年正式推出市场。 从英国建立起第一间盘房，同时期进入亚洲市场，是属于非常前期进入亚洲市场的欧洲公司。易胜博体育平台成功经营20年，这起源于，我们提倡企业化管理，永续经营的概念。</div>
                <div class="Specialty">
                  <span>专业的服务</span>
                  <span>优质的产品</span>
                  <span>精准的数据</span>
                  <span>全面的赛事</span>
                  <div style="clear: both;overflow: hidden;"></div>
                </div>
              </div>
              <!-- <div class="Introduction-info">
                <div class="Introduction-text">
                  <span>我们拥有自己的技术团队，自家独立创作软件，不使用3方操盘软件，保证操作的独立性，同时确保更新与创造掌握在自己的手上，并且，我们的系统已经经历了4次换代大更新，现有的系统更加稳定，强大，快速。</span>
                  <span>易胜博体育操盘团队超过250人，分布于南美洲（美洲运动，篮球，网球）欧洲（足球，网球），及亚洲（东亚，东南亚各赛事）。几个团队透过操盘系统紧密结合，接收来自于全球各地的体育信息，透过欧洲数学专家提供初始赔率同时加上亚洲人操盘的习性，创造出易胜博独特的体育风格。近20年来，易胜博的体育盘口长期被各大体育资讯、指数平台甚至官方体彩引用和借鉴，是很多大型体育赛事盘口的风向标和基准石。</span>
                  <span>我们在经营上稳打稳扎，步步为营，但在体育投注竞猜上勇于创新，独家体育提前结算功能，赛中隨时胜先取，負少賠，已经陆续登场。易胜博体育为实时结算任何投注只要成绩确定，即可派彩。我们提供的球赛选择众多，主要针对经营足球，篮球与网球。</span>
                  <span>在生意层面上，我们为伙伴提供的不单止是体育操盘，我们也同时提供专业的风险管理。我们相信，风险管理在体育投注里面占了一个重要的环节</span>
                </div>
              </div> -->
              <img class="people" src="../../static/nv.png" alt="">
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <div class="main">
      <div class="container">
        <!-- 楼层一 -->
        <div class="partner row">
          <a target="_blank" href="" v-for="(item,i) in parList" :key="i">
            <div class="partner-item" :style="{'background-image':'url(./static/par' + item.num + '.png)'}">
              <span>{{item.title}}</span>
              <span>{{item.text}}</span>
            </div>
          </a>
        </div>
        <a href="https://messenger.nebestbox.com/messenger/0zj7makr1n6xt0ymxwgjszycbg.html" class="phone-kefu row">
          <div class="col-5">
            <span>联系在线客服</span>
            <span>获取 <font style="color:#bc3dec"><b>易胜博</b></font></span>
            <span>最新游戏网址</span>
          </div>
          <div class="col-5">
            <div class="day-time">
              <span>7X24小时</span>
              <span>在线客服</span>
            </div>
          </div>
        </a>
        <div class="warpper">
          <!-- 楼层二 易胜博指数 -->
          <!-- <div class="ysb row" >
            <div class="data-items">
              <div class="data-title">初始指数</div>
              <div class="data-English">HE INITIAL INDEX</div>
              <div class="ysb-data">
                <div class="ysb-data-item">
                  <div class="ysb-data-span">
                    <span>主队</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>让球</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>客队</span>
                    <span>0.98</span>
                  </div>
                </div>
                <div class="ysb-data-item">
                  <div class="ysb-data-span">
                    <span>主胜</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>和局</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>客胜</span>
                    <span>0.98</span>
                  </div>
                </div>
                <div class="ysb-data-item">
                  <div class="ysb-data-span">
                    <span>大球</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>大小</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>小球</span>
                    <span>0.98</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="data-items-center">
              <div class="data-title-center">易胜博指数</div>
              <div class="data-English-center">YI SHENGBO INDEX</div>
              <div class="ysb-data-center">
                <div class="data-top row-around">
                  <div class="data-top-item">
                    <img src="../../static/par2.png" alt="">
                    <span>萨尔米安杜</span>
                  </div>
                  <div class="data-top-item-center">
                    <span>巴西乙</span>
                    <span>11-23 08:30</span>
                  </div>
                  <div class="data-top-item">
                    <img src="../../static/par2.png" alt="">
                    <span>萨尔米安杜</span>
                  </div>
                </div>
                <div class="data-bottom">
                  <div class="row-around">
                    <div class="data-bottom-item">
                      <span>胜</span>
                      <span>1.6</span>
                    </div>
                    <div class="data-bottom-item">
                      <span>平</span>
                      <span>1.6</span>
                    </div>
                    <div class="data-bottom-item">
                      <span>负</span>
                      <span>1.6</span>
                    </div>
                  </div>
                  <div class="row-around score">
                    <div>3</div>
                    <div>:</div>
                    <div>2</div>
                  </div>
                  <div class="next">
                    <span>上一个</span>
                    <span>下一个</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="data-items">
              <div class="data-title">即时指数</div>
              <div class="data-English">THE INITIAL INDEX</div>
              <div class="ysb-data">
                 <div class="ysb-data-item">
                  <div class="ysb-data-span">
                    <span>主队</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>让球</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>客队</span>
                    <span>0.98</span>
                  </div>
                </div>
                <div class="ysb-data-item">
                  <div class="ysb-data-span">
                    <span>主胜</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>和局</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>客胜</span>
                    <span>0.98</span>
                  </div>
                </div>
                <div class="ysb-data-item">
                  <div class="ysb-data-span">
                    <span>大球</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>大小</span>
                    <span>0.98</span>
                  </div>
                  <div class="ysb-data-span">
                    <span>小球</span>
                    <span>0.98</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- 楼层三 积分榜 -->
          <div class="ranking">
            <div class="data-title-center">易胜博指数</div>
            <div class="data-English-center">YI SHENGBO INDEX</div>
            <div class="ranking-main">
              <!-- <div class="ranking-title row">
                <div><span>总积分榜</span></div>
                <div><span>主场积分</span></div>
                <div><span>客场积分</span></div>
                <div><span>半场总积分</span></div>
                <div><span>半场主场积分</span></div>
                <div><span>半场客场积分</span></div>
              </div> -->
               <!-- 表单数据 -->
            <div class="table-outer">
              <div class="table">
                <!-- <div class="table-left">
                  <div class="table-left-pai">
                    <table>
                      <tr><td>排名</td></tr>
                    </table>
                  </div>
                  <div class="table-left-num">
                    <table>
                      <tr v-for="(item,i) in 20" :key="i"><td>{{item}}</td></tr>
                    </table>
                  </div>
                </div> -->
                <div class="table-top">
                  <div class="table-top-ab">
                    <div class="table-top-title" ref="topTitle">
                      <table>
                        <tr>
                          <td class="w-big" rowspan="2">时间</td>
                          <td rowspan="2">赛事</td>
                          <td class="team" rowspan="2">主队</td>
                          <td class="team" rowspan="2">客队</td>
                          <td colspan="4">即时欧赔</td>
                          <td class="w-double" colspan="3">初始欧赔</td>
                          <td class="w-double" colspan="3">凯利指数</td>
                        </tr>
                        <tr>
                          <td>主胜</td>
                          <td>平局</td>
                          <td>客胜</td>
                          <td class="w-double">返还率</td>
                          <td>主胜</td>
                          <td>平局</td>
                          <td>客胜</td>
                          <td>凯胜</td>
                          <td>凯平</td>
                          <td>凯负</td>
                        </tr>
                      </table>
                    </div>
                    <div class="table-main">
                      <table>
                        <tr v-for="(item,i) in infoList" :key="i">
                          <td class="w-big">{{item.time}}</td>
                          <td>{{item.league}}</td>
                          <td class="team">{{item.home}}</td>
                          <td class="team">{{item.away}}</td>
                          <td>{{item.imHomeWin}}</td>
                          <td>{{item.imdraw}}</td>
                          <td>{{item.imAwayWin}}</td>
                          <td class="w-double">{{item.ReturnRate}}</td>
                          <td>{{item.inHomeWin}}</td>
                          <td>{{item.indraw}}</td>
                          <td>{{item.inAwayWin}}</td>
                          <td>{{item.Win}}</td>
                          <td>{{item.draw}}</td>
                          <td>{{item.fail}}</td>
                        </tr>
                      </table>
                    </div>
                    <div class="pagination">
                      <div class="block">
                        <el-pagination
                          @current-change="handleCurrentChange"
                          :page-size="num_page"
                          background
                          layout="total, prev, pager, next,jumper"
                          :total="total">
                        </el-pagination>
                      </div>
                    </div> 
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          </div>
          <!-- 楼层四 -->
          <div class="Advantage row">
            <div class="Advantage-main">
              <div class="Advantage-item row">
                <div class="Advantage-img"><img src="../../static/jingzhun.png" alt=""></div>
                <div class="Advantage-item-right">
                  <span>更精准</span>
                  <span>易胜博拥有当前全网最新最全更精准的足球赛事比分更新以及比分预测系统</span>
                </div>
              </div>
            </div>
            <div class="Advantage-main">
              <div class="Advantage-item row">
                <div class="Advantage-img"><img src="../../static/zhuanye.png" alt=""></div>
                <div class="Advantage-item-right">
                  <span>更专业</span>
                  <span>当前网站每日更新大量单场比赛的比分胜负信息以及未开始比赛的比分提前预测</span>
                </div>
              </div>
            </div>
            <div class="Advantage-main">
              <div class="Advantage-item row">
                <div class="Advantage-img"><img src="../../static/quanmian.png" alt=""></div>
                <div class="Advantage-item-right">
                  <span>更全面</span>
                  <span>包含了篮球、美式足球、足球、网球等类的各个赛事的数据</span>
                </div>
              </div>
            </div>
            <div class="Advantage-main">
              <div class="Advantage-item row">
                <div class="Advantage-img"><img src="../../static/gaoxiao.png" alt=""></div>
                <div class="Advantage-item-right">
                  <span>更高效</span>
                  <span>最新技术自主研发的财务处理系统，真正做到极速。独家网络优化技术</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      ©1995-2022 易胜博版权所有
    </div>
    <a :href="herf" target="_bank" class="kefu">
      <span><font style="color:yellow">联系在线客服</font></span>
      <span><font style="color:yellow">获取</font> <b>易胜博</b></span>
      <span><font style="color:yellow">最新游戏网址</font></span>
      <span>在线客服</span>
    </a>
    <!-- <div class="guanyu"><img src="../../static/ysbLfet.png" alt="">关于易胜博</div> -->
  </div>
</template>

<script>
  // import Swiper from 'swiper/dist/js/swiper.min.js';
  import 'swiper/css/swiper.min.css';
export default {
  name: 'index',
  data () {
    return {
      //客服链接
      herf:'',
      //五大联赛
      parList:[
        {url:'#',num:1,title:'英格兰足球超级联赛',text:'通常简称英超，是英格兰足球总会属下的最高等级职业足球联赛。'},
        {url:'#',num:2,title:'意大利足球甲级联赛',text:'通常简称意甲，是意大利最高等级的职业足球联赛。'},
        {url:'#',num:3,title:'西班牙足球甲级联赛',text:'通常简称西甲，是西班牙最高等级的职业足球联赛。'},
        {url:'#',num:4,title:'法国足球甲级联赛',text:'通常简称法甲，是法国最高级别的职业足球联赛。'},
        {url:'#',num:5,title:'德国足球甲级联赛',text:'通常简称德甲，是德国足球最高等级的俱乐部赛事。'},
        {url:'#',num:6,title:'欧洲冠军联赛',text:'通常简称欧冠，是欧洲足球协会联盟主办的年度足球比赛。'},
      ],
      //指数数据
      infoList:[],
      total:100,
      num_page:20,
      page:1
    }
  },
  created(){
    this.getInfo(this.page) 
    if(this.isMobile()){
      this.herf = 'https://messenger.nebestbox.com/messenger/0zj7makr1n6xt0ymxwgjszycbg.html'
    }else{
      this.herf = 'https://messenger.nebestbox.com/messenger/0zj7makr1n6xt0ymxwgjszycbg.html'
    }
  },
  methods:{
    getInfo(page){
      this.axios.get('https://www-ysb.com/info1.php?page='+page).then(res => {
      this.total = res.data.total
      this.num_page = res.data.num_page
      this.infoList = res.data.data
    })
    },
    handleCurrentChange(val){
      this.getInfo(val) 
    },
    //检测手机端函数
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted(){
    
  },
 
}
</script>

<style scoped>
  /* .swiper-pagination >>>.my-bullet-hover{background: #cf3d36} */
  .phone-kefu{display: block; color: #000; border: 1px solid #bbb;padding: 10px 0px;margin-bottom: 1.5rem;font-size: 1.5rem;display: none}
  .phone-kefu span{display: block}
  .phone-kefu .day-time{
    border-radius: 10px;
    width: 90%;
    margin: 0 auto;
    margin-top: .4rem;
    background: #fff; 
  }
  .phone-kefu .day-time span:first-child{
    color: white;
    font-weight: bold;
    background: linear-gradient(90deg,#5d44af,#bc3dec);
    letter-spacing: 2px;
    padding: 5px 0;
    border-top: 1px solid #bbb;
    border-left: 1px solid #bbb;
    border-right: 1px solid #bbb;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .phone-kefu .day-time span:last-child{
    color: #bc3dec;
    letter-spacing: 2px;
    padding: 5px 0 5px 35px;
    background: url(../../static/kefu.png);
    background-size: 30px;
    background-repeat: no-repeat;
    background-position: 10px center;
    border-bottom: 1px solid #bbb;
    border-left: 1px solid #bbb;
    border-right: 1px solid #bbb;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .container {
    margin-right: auto;
    margin-left: auto;
  }
  .row-around{
    display: flex;
    justify-content:space-around;
  }
  .row:after{
    content: '';
    height: 0;
    display: block;
    clear: both;
  }
  .col-1{width: 10%;float: left;}
  .col-2{width: 20%;float: left;}
  .col-3{width: 30%;float: left;}
  .col-4{width: 40%;float: left;}
  .col-5{width: 50%;float: left;}
  .col-6{width: 60%;float: left;}
  .float-l{float: left;}
  .float-r{float: right;}
  .container {
    margin-right: auto;
    margin-left: auto;
  }
  .header{position: relative;width: 100%;height: 5rem;}
  .header img:first-child{position: absolute;left: 0;width: 100%;height: 100%;}
  .header img:last-child{
    position: absolute;
    left: 0;
    right: 50%;
    width: 52.4%;
    transform: translate(50%, 0%);
    z-index: 999;
  }
  /* .Carousel{
    background-image: url(../../static/banner2.jpg);
    background-size: 100%;
    background-repeat: no-repeat;
  } */
  .swiper-slide{
    
    /* background-size: 100% 100%;
    background-repeat: no-repeat; */
  }
  /* 轮播中间介绍 */
  .Introduction-wapper{position:absolute;}
  .Introduction{
    margin-top: 5rem;
    margin-left: 20%;
    width: 52.5%;
    border-radius: 1rem;
    margin-bottom: 9rem;
    position: relative;
  }
  .Introduction .people{
    position: absolute;
    top: 0%;
    right: -35%;
    width: 40%;
  }
  .Introduction-text span{
    width: 95%;
    display: block;
    font-size: 1rem;
    padding-bottom: .3rem;
    margin-bottom: .3rem;
    border-bottom: 1px solid #e3e3e3
  }
  .Introduction-header{
    background: #00000000;
    text-align: left;
    padding: 1rem 0 1.5rem 1rem;
    position: relative;
    max-height: 250px;
    overflow: hidden;
  }
  .Introduction-header .team-logo{
    position: absolute;
    top: 1rem;
    right: 1%
  }
  .Introduction-header .country{
    font-family: 'MicrosoftYaHei';
    font-size: 1rem;
    color: #ffffff;
  }
  .Introduction-header .name{
    font-family: 'HYYaKuHeiW';
    font-size: 4rem;
    font-weight: bold;
    color: #000000cc;
  }
  .Introduction-header .resume{
    font-family: 'MicrosoftYaHei';
	  font-size: 1rem;
    color: #000000cc;
    margin-bottom: 1rem;
    width: 90%;
  }
  .Introduction-header .Specialty span{
    display: block;
    float: left;
    margin: 0 .5rem;
    background-image: linear-gradient(0deg, 
      #fff 0%, 
      #fff 53%, 
      #fff 100%), 
    linear-gradient(
      #fff, 
      #fff);
    background-blend-mode: normal, 
      normal;
    border-radius: 0.6rem;
    border: solid 1px #292929;
    font-family: MicrosoftYaHei-Bold;
	  font-size: 1.1rem;
    font-weight: bold;
    color: #000000cc;
    padding: .6rem 2rem
  }
  .Introduction-header .Specialty span:first-child{margin-left: 0}
  .Introduction-info{
    padding: 1rem 0 0rem 1rem;
    background: #fff;
    text-align: left;
    font-size: 0.9rem;
    max-height: 290px;
    overflow: hidden;
  }
  .Introduction-info ul{border-top: 1px solid #e3e3e3;width: 95%;padding: 7px 0}
  .Introduction-info li{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .Introduction-info .info-item-name{color: #cd2a2f}
  /* 数据主体 */
  .main{
    background-image: url(../../static/backgroundImage.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .main .container{
    padding: 8px 8px 0 8px;
  }
  .main .container .warpper{
    border-top: 1px solid #bbb;
    border-left: 1px solid #bbb;
    border-right: 1px solid #bbb;
    padding: 2rem;
    background: #fff; 
  }
  /* 五大联赛 */
  .partner{
    background: #fff;
    padding: 1rem 0;
    margin: 1rem 0;
    border: 1px solid #bbb;
    background-image: url(../../static/football.png) ;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .partner a{
    display: block;
    width: 20%;
    float: left;
    color: #000;
    transition: all .3s;
  }
  .partner a:last-child{display: none}
  .partner a:hover{
    transform: scale(1.06);
  }
  .partner-item {
    width: 60%;
    margin: 0 auto;
    height: 75px;
    padding: 7px 5px 7px 64px;
    background: #f1f1f1;
    border: 1px solid #e2e2e2;
    background-repeat: no-repeat;
    background-position: 10px center;
    background-size: 48px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 10px #d1d1d1;
    box-shadow: 0px 0px 10px #d1d1d1;
  }
  .partner-item span:first-child{
    display: block;
    font-size: 17px;
  }
  .partner-item span:last-child{
    margin-top: .4rem;
    display: block;
    font-size: 12px;
    text-align: left;
  }
  /* 易胜博指数 */
  .data-items{width: 30%;float: left;}
  .data-items-center{width: 40%;float: left;}
  .data-English{
    font-size: .6rem;
    letter-spacing: .6px;
    color: #6f6f6f;
    opacity: 0.39;
    font-family: 'MicrosoftYaHei-Bold';
  }
  .data-English-center{
    font-size: 1.5rem;
    letter-spacing: 1.6px;
    color: #6f6f6f;
    opacity: 0.39;
    font-family: 'BDZYJT--GB1-0';
  }
  .data-title{
    font-size: 1.6rem;
    margin-top: 5rem;
    letter-spacing: 1.5px;
    font-weight: bold;
  }
  .data-title-center{
    font-size: 3.1rem;
    letter-spacing: 3px;
    font-weight: bold;
  }
  .ysb-data{
    width: 100%;
    padding: 1rem 0;
    margin-top: 1rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 1.8rem 0rem 
      rgba(54, 54, 54, 0.52);
    border-radius: 0.6rem;
    transition: all .3s;
  }
  .ysb-data-center{
    width: 90%;
    margin: 0 auto;
    height: 20.1rem;
    margin-top: 3rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 1.8rem 0rem 
      rgba(54, 54, 54, 0.52);
    border-radius: 0.6rem;
    transition: all .3s;
  }
  .ysb-data:hover,.ysb-data-center:hover{transform: scale(1.05)}
  .ysb-data-item{
    width: 92%;
    margin: 2rem auto;
    display: flex;
    justify-content:space-between;
  }
  .ysb-data-item:first-child{margin-top: 0;}
  .ysb-data-item:last-child{margin-bottom: 0;}
  .ysb-data-span span:first-child{
    display: block;
    width: 105px;
    height: 1.7rem;
    line-height: 1.7rem;
    color: #fff;
    font-size: 1.1rem;
    background-image: linear-gradient(to top,  #cb3937 0%,  #d55155 100%);
    background-blend-mode: normal, 
      normal;
    border-radius: 0.3rem 0.3rem 0rem 0rem;
  }
  .ysb-data-span span:last-child{
    display: block;
    width: 103px;
    height: 1.7rem;
    line-height: 1.7rem;
    border-radius: 0rem 0rem 0.3rem 0.3rem;
    border: 1px solid #d55155;
  }
  .data-top{
    width: 100%;
    height: 150px;
    background-image: url(../../static/vs.png) ;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .data-top-item span{
    display: block;
    margin: 0 auto;
    color: #fff;
    margin-top: .5rem;
  }
  .data-top-item-center span{
    display: block;
    margin: 0 auto;
    margin-top: .3rem;
    color: #000;
    font-family: MicrosoftYaHei;
  }
  .data-top-item-center span:first-child{font-size: 1.4rem}
  .data-top-item-center span:last-child{font-size: .9rem}
  .data-top-item img{
    max-width: 80px;
    max-height: 80px;
    display: block;
    margin: 0 auto;
    margin-top: 2rem;
  }
  .data-bottom-item{
    margin-top: .5rem;
    width: 5.7rem;
	  height: 2.4rem;
    background-color: #e5e5e5;
  }
  .data-bottom-item span{
    display: block;
    width: 100%;
    font-size: .8rem;
    margin-top: .1rem;
  }
  .data-bottom-item span:first-child{margin-top: .2rem;}
  .score{
    font-family: 'MicrosoftYaHei';
	  font-size: 4.5rem; 
  }
  .next span{
    border-radius: .9rem;
    border: solid 1px #363636;
    padding: .3rem .8rem;
    cursor: pointer;
  } 
  .next span:hover{
    background-image: linear-gradient(to top, #cf3c3b, #ef595d);
    color: #fff;
    border: solid 1px #cb3937;
  }
  .next span:first-child{margin-right: .5rem}
  .next span:last-child{margin-left: .5rem}
  /* 积分榜 */
  .ranking-main{
    margin-top: 1rem;
    padding-top: 1rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 1rem 0rem 
      rgba(54, 54, 54, 0.2);
    border-radius: 0.6rem;
  }
  .ranking-title{margin-bottom: .5rem;}
  .ranking-title div{width: 16.666667%;float: left;}
  .ranking-title span{
    display: inline-block;
    width: 10rem;
    height: 2.5rem;
    font-size: 22px;
    color: #272727;
    line-height: 2.5rem;
    border-radius: 22px;
    border: solid 1px #5c5c5c;
    cursor: pointer;
    transition: all .3s;
    background: linear-gradient(to top,#ffffff 0%,#f0f0f0 50%,#f8f8f8 74%,#ffffff 100%);
  }
  .ranking-title .active{
    background-image: linear-gradient(to top, #cf3c3b, #ef595d);
    color: #fff;
    border: solid 1px #cb3937;
  }
  /* 榜单数据 */
  .table-outer{padding: 10px}
  .table{
    background-color: #fff;
	  border: solid 1px #bbb;
  }

  .table-left-pai table,.table-left-num table,.table-left-num tr,td{
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0px;
  }
  .table-top{background: linear-gradient(90deg, #5d44af, #bc3dec);color: #fff;}
  .table-top table{border-collapse: collapse; border-spacing: 0px;}
  .table-top td{border-top: none;}
  .table-top tr td:first-child{border-left: 0}
  .table-top tr td:last-child{border-right: 0}
  .w-double{width: 90px}
  .w-big{width: 120px}
  .team{width: 185px}
 
  td{
    padding: 0;
    height:40px;
    width: 65px;
    font-size: 16px;
    vertical-align:center;
    text-align:center;
    border: 1px solid #c7c7c7;
    border-collapse:collapse;
  }
  /* .table-left{width: 52px;float: left;} */
  .table-top{float: left;width: 1242px;}
  /* .table-left-pai{background: linear-gradient(to top, #cf3c3b, #ef595d);color: #fff;}
  .table-left-pai td{border:none} */
  .table-main tr:nth-child(odd),.table-left-num tr:nth-child(odd){
    background: #ebebeb;
  }
  .table-main{background: #fff;color: #000}
  .table-main td{border: 1px solid #c7c7c7;}
  .table-main tr td:first-child{border-left: 0}
  .table-main tr td:last-child{border-right: 0}
  
  /* 分页器 */
  .pagination{background: #ebebeb;height: 50px;position: relative;}
  .pagination .block{position: absolute;top: 50%;left:50%;transform: translate(-50%,-50%)}
  .pagination >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
    background: linear-gradient(to top, #5d44af, #bc3dec);
    color: #FFF;
  }
  .pagination >>>.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #FFF;
  }
  .pagination >>>.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #bc3dec;
  }
  .pagination >>>.el-input__inner:focus {
    border-color: #bc3dec;
    outline: 0;
  }


  .Advantage{margin-top: 1rem 0}
  .Advantage-main{
    margin-top: 2rem;
    float: left;
    width: 50%;
  }
  .Advantage-item{
    margin: 0 auto;
    width: 80%;
    background-color: #ffffff;
	  box-shadow: 0px 0px 16px 0px 
		rgba(54, 54, 54, 0.2);
  }
  .Advantage-img{
    float: left;
    width: 25%;
    background-image: linear-gradient(to top, #5d44af, #bc3dec);
  }
  .Advantage-img img{width: 80%;transition: all .3s}
  .Advantage-img img:hover{transform: scale(1.15)}
  .Advantage-item-right{float: left;width: 75%}
  .Advantage-item-right span:first-child{
    display: block;
    font-size: 1.8rem;
    letter-spacing: 1.7px;
    font-family: 'MicrosoftYaHei-Bold';
    font-weight: bold;
    text-align: left;
    margin-left: 1rem;
    margin-bottom: .5rem;
  }
  .Advantage-item-right span:last-child{
    display: block;
    font-family: 'MicrosoftYaHei';
	  font-size: 1rem;
    letter-spacing: 1px;
    text-align: left;
    margin: 0 1rem;
  }
  .footer{
    height: 5rem;
    line-height: 5rem;
    background: url(/static/header_bg.png);
	background-size: cover;
    font-family: 'MicrosoftYaHei';
    font-size: 1.5rem;
    letter-spacing: 1.6px;
    color: #fff;
  }
  .slide-img{position: absolute;left: 0;}
  .text-title{
    position: absolute;
    width: 100%;
    color: #fff;
    font-size: 3rem;
    left: 50%;
    transform: translate(-50%,0);
    margin-top: 25%;
  }
  .text-text{
    position: absolute;
    width: 100%;
    color: #fff;
    font-size: 2rem;
    left: 50%;
    transform: translate(-50%,0);
    margin-top: 30%;
  }
  /* 大屏 */
  @media (min-width: 1330px){
    .container {
      width: 1330px;
    }
    
     /* 轮播 */
  /* .swiper-container >>>.swiper-pagination{
    width: 10%;
    height: 360px;
    left: 88%;
    top: 50%;
    transform: translate(0,-50%)
  }
  .swiper-pagination >>>.my-bullet{position: relative;display:inline-block; width: 143px;height: 90px;}
  .swiper-pagination >>>.my-bullet .my-bullet-name{
    display:inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    right: 20%;
    background-color: #fff;
    border-radius: 50%;
    margin-left: 15px;
    z-index: 99999;
    border: 2px solid #ed575a;
    top: 50%;
    transform: translate(0,-50%);
  }
  .swiper-pagination >>>.my-bullet .my-bullet-hover{
    position: absolute;
    visibility:hidden;
    height: 60px;
    line-height: 60px;
    width: 150px;
    z-index: 99;
    top: 50%;
    right: 60%;
    border: 2px solid #fcf900;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    transform: translate(0,-50%);
    background: linear-gradient(to bottom,#ed575a ,#b53535);
    color: #fff;
    font-size: 1.8rem;
    font-weight: bold;
    transition: width .4s ease-out;
  }
  .swiper-pagination >>>.my-bullet:nth-child(1) .my-bullet-name{
    margin-top: 0;
    background-image: url(../../static/ysb.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .swiper-pagination >>>.my-bullet:nth-child(2) .my-bullet-name{
    background-image: url(../../static/tou1.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .swiper-pagination >>>.my-bullet:nth-child(3) .my-bullet-name{
    background-image: url(../../static/tou2.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .swiper-pagination >>>.my-bullet:nth-child(4) .my-bullet-name{
    background-image: url(../../static/tou3.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .swiper-pagination >>>.my-bullet-active .my-bullet-name{background: #ed575a; border: 2px solid #fcf900;}
  .swiper-pagination >>>.my-bullet-active .my-bullet-hover{visibility:visible;width: 200px;} */
  }
  .swiper-pagination >>>.my-bullet{display: inline-block;width: 80px;height: 5px;background: #d77a75;margin-left: 10px;}
  .swiper-pagination >>>.my-bullet-active{background: #cf3d36;}
  .swiper-pagination >>>.my-bullet .my-bullet-hover{display: none}
  /* .guanyu{
    z-index: 9999;
    position: fixed;
    padding: 6px 0;
    width: 35px;
    height: 155px;
    font-size: 1.1rem;
    color: #fff;
    font-weight: bold;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    background: linear-gradient(to top, #cf3c3b, #ef595d);
    left: 0;
    top: 50%;
    transform: translate(0,-50%);
    display: none;
  } */
  .kefu{
    z-index: 9999;
    display: block;
    position: fixed;
    width: 168px;
    height: 346px;
    color: #fff;
    background: url(../../static/kefu1.png) 100% no-repeat;
    right: 0;
    top: 50%;
    transform: translate(0,-50%)
  }
  .kefu span{
    display: block;
    width: 100%;
    height: 31px;
    font-size: 1.5rem;
  }
  .kefu span:first-child{
    margin-top: 12rem;
  }
  .kefu span:last-child{
    margin-top: 24px;
    color: #bc3dec;
    font-weight: bold;
    padding: 0 0 0 12px;
    background: url(../../static/kefu.png);
    background-size: 30px;
    background-repeat: no-repeat;
    background-position: 10px center;
  }
  
  /* 中屏 */
  @media(min-width: 1024px) and (max-width: 1329px){
    .main .container .warpper{padding: 1rem}
    .text-title{font-size: 2.5rem;margin-top: 18%;}
    .text-text{font-size: 1.8rem;margin-top: 23%;}
    /* 头部轮播 */
    .header{height: 3rem;}
    .Introduction{margin-bottom: 7rem}
    .Introduction-info{display: none;}
    .Introduction .people{right: -24%;width: 30%;}
    .Introduction-header .name{font-size: 2.5rem}
    .Introduction-header .Specialty span{font-size: 1rem;padding: .3rem .8rem;margin: 0 .5rem;}
    /* 五大联赛 */
    .partner-item span:first-child{font-size: 13px}
    /* 易胜博指数 */
    .ysb-data-span span:first-child {width: 80px}
    .ysb-data-span span:last-child {width: 78px}
    .data-title-center{font-size: 2.5rem}
    .ysb-data-center{margin-top: 1.5rem}
    .ysb-data{margin-top: .5rem}
    .score{font-size: 4rem}
    /* 积分榜 */
    .ranking-title span{width: 8rem;font-size: 17px;height: 2rem;line-height: 2rem}
    td{width: 44px;font-size: 14px;}
    .w-double{width: 80px}
    .table-left{min-width: 45px;width:5%}
    .table-top{min-width: 858px;width: 100%}
    .table-top table{width: 100%}
    .team{width: 140px}
    .pagination .block{left: 2%;transform: translate(0,-50%)}
    .Advantage-item-right span:first-child{font-size: 1.3rem}
    .Advantage-item-right span:last-child{font-size: .8rem}
    .footer{font-size: 1.1rem;height: 3.5rem;line-height: 3.5rem;}
  }
  /* 中小屏 */
  @media(min-width: 768px) and (max-width: 1023px){
    .main .container .warpper{padding: .5rem}
    /* 头部轮播 */
    .header{height: 2rem;}
    .Introduction-info{display: none;}
    .Introduction{width: 67.5%;margin-bottom: 4rem;margin-left: 10%}
    .Introduction .people{right: -24%;width: 30%;}
    .Introduction-header .name{font-size: 2.5rem}
    .Introduction-header .Specialty span{font-size: 1rem;padding: .3rem .8rem;margin: 0 .5rem;}
    .text-title{font-size: 2.3rem;margin-top: 22%;}
    .text-text{font-size: 1.4rem;margin-top: 28%;}
    /* 五大联赛 */
    .partner{padding-bottom: 0}
    .partner a{width: 33.333333%;margin-bottom: 15px;}
    .partner a:last-child{display: block;}
    .partner-item{height: 65px;}
    .partner-item span:first-child{font-size: 13px}
    /* 易胜博指数 */
    .ysb-data-span span:first-child {width: 55px}
    .ysb-data-span span:last-child {width: 53px}
    .data-title-center{font-size: 2.5rem}
    .ysb-data-center{margin-top: 1.5rem}
    .ysb-data{margin-top: .5rem}
    .score{font-size: 4rem}
    .data-top{height: 140px}
    .data-bottom-item{width: 4.5rem}
    /* 积分榜 */
    .ranking{margin-top: 0;padding-top: 0;}
    .ranking-main{margin-top: .5rem;padding-top: .5rem;}
    .ranking-title div{width: 33.333333%;float: left;margin-bottom: 0.6rem;}
    .ranking-title{margin-bottom: 0;}
    .ranking-title span{width: 6.5rem;height: 2rem;line-height: 2rem;font-size: 15px;}
    .table-outer{padding: 0;}
    td{font-size: 14px;width: 45px;height: 35px;}
    .table-left{width: 14%;}
    .table-top{width: 100%;overflow: auto;position: relative;}
    .table-top-ab{width: 1034px;overflow: auto;}
    .w-double{width: 80px;}
    .w-big{width: 120px;}
    .pagination .block{left: 2%;transform: translate(0,-50%)}

    .Advantage-item-right span:first-child{font-size: 1.3rem}
    .Advantage-item-right span:last-child{font-size: .8rem}
    .footer{font-size: 1.1rem;height: 3.5rem;line-height: 3.5rem;}
  }  /* 手机端 */
  @media (max-width: 767px){
    .phone-kefu{display: block}
    /* .ranking, */
    .Introduction-info,.Introduction .team,.partner-item span:last-child,.kefu,.partner{display: none}
    .main .container .warpper{padding: 5px;}
    .header{height: 2.5rem}
    .header img:first-child{width: 100%}
    .header img:last-child{width: 100%;transform: translate(0%, 0%);}
     /* 轮播 */
    .Introduction{margin-top: 1rem;margin-left: 2%;width: 96.5%;margin-bottom: 1.8rem;}
    .Introduction .people{right: 1%;top: 3%;width: 25%}
    .Introduction-header{height: 182px;padding: .2rem 0 0 .5rem;}
    .Introduction-header .name{font-size: 1.2rem;margin: .3rem 0;}
    .Introduction-header .country,.Introduction-header .resume{font-size: .7rem;width: 74%}
    .Introduction-header .Specialty span{font-size: .8rem;padding: 2px 4px;margin: 0 5px}
    .slide-img{min-height: 230px;}
    .text-title{font-size: 1.3rem;margin-top: 28%;}
    .text-text{font-size: 0.9rem;margin-top: 37%;width: 96%;}
    /* 五大联赛 */
    .partner a{width: 50%;margin-bottom: 15px;}
    .partner a:last-child{margin-bottom: 0;display: block}
    .partner-item{
      padding: 0px 0px 0px 50px;
      background-position: 6px center;
      background-size: 40px;
    }
    .partner-item span:first-child{font-size: 18px;margin-top: 12px;}
    /* 易胜博指数 */
    .data-items,.data-items-center{width: 100%;margin-bottom:.5rem;}
    .data-title{margin-top: 0;font-size: 1.4rem}
    .data-title-center{font-size: 1.9rem}
    .data-English-center{font-size: .9rem}
    .ysb-data{margin-top:.5rem;padding: .8rem 0}
    .ysb-data-center{margin-top:.5rem;width: 100%}
    .ysb-data-item{margin: .7rem auto;}
    .ysb-data-span span:first-child {width: 90px;height: 1.5rem;line-height: 1.5rem;font-size: 1rem}
    .ysb-data-span span:last-child {width: 88px}
    /* 积分榜 */
    .ranking{margin-top: 0;padding-top: 0;}
    .ranking-main{margin-top: .5rem;padding-top: .5rem;}
    .ranking-title div{width: 33.333333%;float: left;margin-bottom: 0.6rem;}
    .ranking-title{margin-bottom: 0;}
    .ranking-title span{width: 6.5rem;height: 2rem;line-height: 2rem;font-size: 15px;}
    .table-outer{padding: 0;}
    td{font-size: 14px;width: 45px;height: 35px;}
    .table-left{width: 14%;}
    .table-top{width: 100%;overflow: auto;position: relative;}
    .table-top-ab{width: 1034px;overflow: auto;}
    .w-double{width: 80px;}
    .w-big{width: 120px;}
    .Advantage-main,.Advantage-item{width: 100%}
    .Advantage-main{margin-top: .5rem;}
    .Advantage-item-right span:first-child{font-size: 1.1rem;margin: .2rem .8rem;}
    .Advantage-item-right span:last-child{font-size: .7rem;margin: 0 .8rem}
    .footer{height: 2.5rem;line-height: 2.5rem;font-size: .8rem}
    .guanyu{display: none}
    .pagination .block{left: 2%;transform: translate(0,-50%)}
  }
   /* 5s */
  @media (max-width: 374px){
    .header{height: 2rem}
    .Introduction-header .Specialty span{margin: 0px}
    .ysb-data-span span:first-child{width: 80px}
    .ysb-data-span span:last-child{width: 78px}
    .ranking-title span{width: 5.5rem;font-size: 13px}
    .phone-kefu{font-size: 1.3rem}
    .phone-kefu .day-time span:last-child{background-position: 5px center;}
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue